import type { AemBookingDay, ITimeSlot } from 'Types/aemui/schedule-a-tour/scheduleATour';
import type {
	IBookingsServiceResponse,
	IBookingsStaffAvailabilityResponse
} from 'Types/bookings/bookings';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const PacificStandardTime = 'Pacific Standard Time';
const MountainStandardTime = 'Mountain Standard Time';
const CentralStandardTime = 'Central Standard Time';
const EasternStandardTime = 'Eastern Standard Time';
const ArizonaStandardTime = 'US Mountain Standard Time';

export function getAvailableTimeSlots(
	service: IBookingsServiceResponse,
	availability: IBookingsStaffAvailabilityResponse,
	timeZone: string,
	bookingsBusiness: string
): AemBookingDay[] {
	const staffId = availability.value[0].staffId;
	const serviceId = service.value[0].id;
	const openTimes = availability.value[0].availabilityItems.filter((x) => x.status === 'available');
	const availableResponse = getBaseArray();
	const serviceDuration = getDurationInMinutes(service.value[0].defaultDuration);

	openTimes.forEach((element) => {
		const start = dayjs.utc(element.startDateTime.dateTime);
		const end = dayjs.utc(element.endDateTime.dateTime);

		const numberOfSlots = end.diff(start, 'minutes') / serviceDuration;

		for (let j = 0; j < numberOfSlots; j++) {
			const k = j + 1;
			const slot = {
				startTime: start
					.add(j * serviceDuration, 'minute')
					.tz(timeZone)
					.toISOString(),
				endTime: start
					.add(k * serviceDuration, 'minute')
					.tz(timeZone)
					.toISOString(),
				staffId: staffId,
				serviceId: serviceId,
				displayTime: start.add(j, 'hour').tz(timeZone).format('HH:mm a'),
				timeZone: timeZone,
				duration: parseDuration(service.value[0].defaultDuration),
				bookingsBusiness: bookingsBusiness
			} as ITimeSlot;

			const dayObject = availableResponse.find(
				(x) => x.dayObject.format('DD/MM/YYYY') === dayjs(start).tz(timeZone).format('DD/MM/YYYY')
			);

			dayObject?.timeSlots.push(slot);
		}
	});

	return availableResponse;
}

function getBaseArray(): AemBookingDay[] {
	const array = [] as AemBookingDay[];

	for (let i = 0; i < 14; i++) {
		const day = {} as AemBookingDay;
		day.dayObject = dayjs().add(i, 'day');
		day.timeSlots = [] as ITimeSlot[];
		array.push(day);
	}

	return array;
}

function parseDuration(duration: string): string {
	let result = duration.replace('PT', '');
	if (result.endsWith('H')) {
		result = result.replace('H', '');
		return `${result} Hour${parseInt(result) > 1 ? 's' : ''}`;
	} else {
		result = result.replace('M', '');
		return `${result} Minute${parseInt(result) > 1 ? 's' : ''}`;
	}
}

function getDurationInMinutes(duration: string): number {
	let result = duration.replace('PT', '');
	if (result.endsWith('H')) {
		result = result.replace('H', '');
		return parseInt(result) * 60;
	} else {
		result = result.replace('M', '');
		return parseInt(result);
	}
}

//I don't love this but it's a stop gap until we can get a 3rd party library approved for this translation
//I looked through the club store and at least it seems we've standardized thoes to these 5
export function getWindowsTimeZone(ianaTimezone: string): string {
	switch (ianaTimezone) {
		case 'America/Los_Angeles':
			return PacificStandardTime;
		case 'America/Chicago':
			return CentralStandardTime;
		case 'America/Denver':
			return MountainStandardTime;
		case 'America/New_York':
			return EasternStandardTime;
		case 'America/Phoenix':
			return ArizonaStandardTime;
		default:
			return 'UTC';
	}
}
